export { default } from './LoggedInPage';
